import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useAutoIdContext } from './AutoIdProvider';
export default function useId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id-';
  var getId = useAutoIdContext();

  var _useState = useState(() => "".concat(prefix).concat(getId())),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  return id;
}